import React from "react";
import PropTypes from "prop-types";
import { Button, Typography, CircularProgress, Box } from "@mui/material";

export default function TertiaryButton({
  id,
  label,
  onClick,
  disabled,
  isLoading,
  size,
  width,
  startIcon,
  color
}) {
  const StartIcon = startIcon;

  return (
    <Button
      id={id}
      onClick={onClick}
      disabled={disabled}
      sx={{
        width: width,
        minWidth: "32px",
        textTransform: "none",
        borderRadius: "4px",
        color: color || "black_solid.70",
        padding: size === "small" ? "2px 4px" : "4px 6px",
        "&:hover": {
          backgroundColor: "black_opacity.10",
          color: color || "black_solid.70",
          textDecoration: "underline"
        },
        "&:focus": {
          backgroundColor: "black_opacity.10",
          color: color || "black_solid.70",
          textDecoration: "underline"
        },
        "&:active": {
          color: "primary.60",
          textDecoration: "none"
        },
        "&:disabled": {
          color: "black_opacity.30"
        },
      }}
    >
      {isLoading ? (
        <CircularProgress sx={{ color: "black_solid.70" }} size={size === "small" ? 16 : 20} />
      ) : (
        <Box sx={{ display: "inline-flex", alignItems: "center" }}>
          {startIcon && <StartIcon sx={{ fontSize: size === "small" ? "16px" : "20px", ...label && { marginRight: "4px" } }} />}
          <Typography
            variant={size === "small" ? "button2" : "button1"}
          >
            {label}
          </Typography>
        </Box>
      )}
    </Button>
  );
}

TertiaryButton.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  size: PropTypes.string,
  width: PropTypes.string,
  startIcon: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func
  ]),
  color: PropTypes.string
};